<template>
  <list :listTitle="$t('logs.label')" filterTitle="Filtro" :loading="loading" :total="logsTotal" :emitChangeOnCreated="false" @change="onChange" v-on:loadMore="loadMore" @clearFilters="clearFilters">
    <template slot="filters">
      <form-group :label="$t('identifier.label')">
        <input class="form-input" v-model="options.identifier">
      </form-group>

      <form-group :label="$t('scope.label')">
        <select v-model="options.scope" class="form-select">
          <option :value=null>Todos</option>
          <option value="order*">{{ $t('order.label') }}</option>
          <option value="product*">{{ $t('product.label') }}</option>
          <option value="price*">{{ $t('price.label') }}</option>
          <option value="stock*">{{ $t('stock.label') }}</option>
          <option value="feed*">{{ $t('feed.label') }}</option>
          <option value="token*">{{ $t('token.label') }}</option>
          <option value="user_action*">{{ $t('user_action.label') }}</option>
        </select>
      </form-group>

      <form-group :label="$t('module.label')">
        <select v-model="options.moduleOption" class="form-select">
          <option :value=null>Todos</option>
          <option v-for="module in modules" :key="module" :value="`${module.type}.${module.identifier}`">{{ $t(module.type).label }} {{ $t(module.identifier).label }}</option>
        </select>
      </form-group>

      <form-group :label="$t('level.label')">
        <select v-model="options.level" class="form-select">
          <option :value=null>Todos</option>
          <option value="critical">{{ $t(`level.critical.label`) }}</option>
          <option value="warning">{{ $t(`level.warning.label`) }}</option>
          <option value="info">{{ $t(`level.info.label`) }}</option>
        </select>
      </form-group>

      <form-group label="Data">
        <el-date-picker
          v-model="updatedDate"
          type="datetimerange"
          format="dd/MM/yyyy HH:mm"
          start-placeholder="Data Inicial"
          end-placeholder="Data Final">
        </el-date-picker>
      </form-group>
    </template>

    <div class="l-col-12@md" v-if="dataLogs.length">
      <time-line :items="dataLogs"/>
    </div>
    <div class="l-col u-textCenter" v-else>
      <panel>Nenhum histórico encontrado.</panel>
    </div>
  </list>
</template>

<script>
  import List from '@/components/shared/list/Scroll'
  import Panel from '@/components/template/Panel'
  import { merge } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import FormGroup from '@/components/template/FormGroup'
  import TimeLine from '@/components/template/timeLine/Template'

  export default {
    data: () => ({
      loading: false,
      options: {
        identifier: null,
        level: null,
        scope: null,
        moduleOption: null,
        'module_type': null,
        'module_identifier': null,
        updatedStart: null,
        updatedEnd: null
      },
      updatedDate: [],
      sortFields: [
        'identifier',
        'level',
        'scope',
        'module'
      ],
      dataLogs: []
    }),
    created () {
      merge(this.options, this.lastFilters)

      if (this.options.updatedStart && this.options.updatedEnd) {
        this.updatedDate = [
          this.options.updatedStart,
          this.options.updatedEnd
        ]
      }
    },
    methods: {
      ...mapActions('logs', [
        'fetch',
        'fetchMore'
      ]),
      async onChange (options) {
        this.loading = true

        merge(this.options, options)

        await this.fetch({
          options: this.options
        })

        this.loading = false
      },
      getIconByLevel (level) {
        switch (level) {
          case 'info':
            return 'icon-info2'

          case 'warning':
            return 'icon-warning2'

          case 'critical':
            return 'icon-cancel-circle2'
        }
      },
      async loadMore (options) {
        merge(this.options, options)

        await this.fetchMore({
          options: this.options
        })

        options.fetchingMore = false
      },
      clearFilters () {
        this.updatedDate = []
      }
    },
    computed: {
      ...mapFields({
        logsTotal: 'logs.total',
        logsLogs: 'logs.logs',
        lastFilters: 'logs.lastFetchOptions'
      }),
      ...mapGetters('module', [
        'definitionModulesInstalled'
      ]),
      modules () {
        return this.definitionModulesInstalled
      }
    },
    watch: {
      'options.moduleOption' (value) {
        if (value === null) {
          this.options['module_type'] = null
          this.options['module_identifier'] = null
        } else {
          this.options['module_type'] = value.split('.')[0]
          this.options['module_identifier'] = value.split('.')[1]
        }
      },
      logsLogs (logs) {
        this.dataLogs = []

        if (logs.length) {
          for (let i in this.logsLogs) {
            const log = this.logsLogs[i]

            this.dataLogs.push({
              id: i,
              icon_class: this.getIconByLevel(log.level),
              icon_status: `t-${log.level}`,
              title: log.identifier + ' ' + log.message,
              controls: [],
              updated: log.updated,
              dataJSON: log.privateData
            })
          }
        }
      },
      updatedDate (value) {
        if (value[0]) {
          this.options.updatedStart = value[0]
        }

        if (value[1]) {
          this.options.updatedEnd = value[1]
        }
      }
    },
    components: {
      List,
      Panel,
      FormGroup,
      TimeLine
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?100022c3